import { render, staticRenderFns } from "./StatisticsRequisitesRequisites.vue?vue&type=template&id=5fe60d88&scoped=true&"
import script from "./StatisticsRequisitesRequisites.vue?vue&type=script&lang=js&"
export * from "./StatisticsRequisitesRequisites.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsRequisitesRequisites.vue?vue&type=style&index=0&id=5fe60d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe60d88",
  null
  
)

export default component.exports